import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../../routes/routeKeys";
import { FiAlertCircle, FiHome } from "react-icons/fi";
import bgImage from "../../assets/images/trioakBg.png";

const PageNotFound = () => {
  return (
    <div 
      className="flex flex-col items-center justify-center min-h-screen text-center px-4"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      <div className="flex flex-col items-center max-w-lg w-full transition-all">
        <div className="text-red-600 mb-4 drop-shadow-md">
          <FiAlertCircle size={64} strokeWidth={1.5} />
        </div>
        <h1 className="text-8xl font-black text-gray-900 tracking-tighter mb-2 drop-shadow-xl">
          404
        </h1>
        <h3 className="text-3xl font-extrabold text-gray-800 mb-4 drop-shadow-md">
          Page Not Found
        </h3>
        <p className="text-gray-800 font-medium mb-8 text-lg px-2 leading-relaxed drop-shadow">
          Oops! The page you are looking for has gone missing, changed its name, or doesn't exist anymore.
        </p>
        <Link 
          to={ROUTES.DASHBOARD} 
          className="flex items-center gap-2 bg-[#2d5b30] text-white px-6 py-3 rounded-full font-bold hover:bg-[#1e4120] transition-all duration-300 shadow-2xl hover:shadow-xl transform hover:-translate-y-1"
        >
          <FiHome size={20} />
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;
